import React from 'react';
import {HashRouter, Switch, Route} from 'react-router-dom';

import App from './App'
import AllProjects from './AllProjects'

const Router = () => (
  <HashRouter basename={process.env.PUBLIC_URL}>
    <Switch>
      <Route path="/" component={App} exact/>
      <Route path="/all_projects" component={AllProjects}/>
    </Switch>
  </HashRouter>
)

export default Router